module.exports = __webpack_public_path__ + "img/file.a7d3a268.svg";